'use client';
import { Chart as ChartComponent } from '../content-types/Chart';
import { parseChartData } from '@/app/utils/parseChartData';

const Chart = ({ ...props }) => {
    const attrsData = props?.attrs?.data || {};
    const { data: dataField, ...otherProps } = attrsData;

    const parsedData = parseChartData(dataField);

    return <ChartComponent data={parsedData} {...otherProps} />;
};

export { Chart };
